import { toast } from 'react-toastify';

const showWarning = (message) => {
  toast.warn(message);
};

export default showWarning;
